import {
    CartItemInput,
    CartItemInterface,
    ProductInterface
} from '@pylot-data/pylotschema'
import { CartData } from '../use-cart'
import { processItemPrice } from './optimisticAddToCart/processItemPrice'
import { processConfigurableItem } from './optimisticAddToCart/processConfigurableItem'
import { processGiftCardItem } from './optimisticAddToCart/processGiftCardItem'

export const getOptimisticAddToCartData = (
    cartData: CartData,
    cartItems: CartItemInput[],
    products: ProductInterface[]
): CartData => {
    const items = [...(cartData?.data?.cart?.items || [])]
    cartItems.forEach((cartItem, idx) => {
        const itemSku = cartItem.parent_sku ?? cartItem.sku
        const product = products.find(
            (productItem) => productItem.sku === itemSku
        )
        if (!product) {
            return
        }

        // We don't know the item ID/UID yet, so we are using index in the array instead
        const item: CartItemInterface = {
            product,
            id: String(idx),
            uid: String(idx),
            quantity: cartItem.quantity
        }
        processItemPrice(item, product.price_range.minimum_price)
        processConfigurableItem(cartItem, item, product)
        processGiftCardItem(cartItem, item, product)
        items.push(item)
    })

    return {
        data: {
            cart: {
                ...cartData.data.cart,
                items
            },
            isOptimistic: true
        }
    }
}
